export default __webpack_public_path__ + "static/media/todo.9ebc3bfd.gif";